import URL from '@/api/URL';
import fetch from '@/api/fetch';

export function getApplyList(params) {
  return fetch.post(URL.getApplyList, params);
}

export function exportArrangeFile(params) {
  return fetch.post(URL.exportArrangeFile, params);
}

export function getApplyDetail(params) {
  return fetch.post(URL.getApplyDetail, params);
}

export function updateApplyDetail(params) {
  return fetch.post(URL.updateApplyDetail, params);
}

export function getDictionaryList(params) {
  return fetch.post(URL.getDictionaryList, params);
}

export function deleteDictionary(params) {
  return fetch.post(URL.deleteDictionary, params);
}

export function insertOrUpdateDictionary(params) {
  return fetch.post(URL.insertOrUpdateDictionary, params);
}

export function updateDictionary(params) {
  return fetch.post(URL.updateDictionary, params);
}

export function addApplyInfo(params) {
  return fetch.post(URL.addApplyInfo, params);
}

export function getAddApplyInfo(params) {
  return fetch.post(URL.getAddApplyInfo, params);
}

export function synchroClassInfo(params) {
  return fetch.post(URL.synchroClassInfo, params);
}
// 查询当前组织下应用列表

export function pianapplist(params) {
  return fetch.post(URL.pianapplist, params)
}


// WEBPACK FOOTER //
// ./src/api/modules/applyMange.js